export const SAVE_DASHBOARD_CHECKBOXES_VALUES =
  "SAVE_DASHBOARD_CHECKBOXES_VALUES";
export const SAVE_HISTORY_CHECKBOXES_VALUES = "SAVE_HISTORY_CHECKBOXES_VALUES";
